import { selectFeatureFlags } from 'core/userContext';
import { useQueryContext } from 'modules/billing/contexts/QueryContext';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Button, BUTTON_VARIANTS } from 'ui/button';
import {
  ARROW_DIRECTION_RIGHT,
  ARROW_DIRECTION_UP,
  CollapsibleContent,
  CollapsibleContentArrow,
} from 'ui/collapsibleContent';
import { borderColors, spacing } from 'ui/theme';
import { AnalyticTable, TableMetric } from '../AnalyticTable';
import { EMAIL_BREAKDOWN_TABLE_COLUMNS } from './constants';
import { createEmailTableRows, createSmsTableColumns, createSmsTableRows } from './utils';

const TableActionWrapper = styled.div`
  padding-top: ${spacing.base};
  padding-bottom: ${spacing.base};
  margin-top: ${spacing.base};
  border-top: ${spacing.single} solid ${borderColors.borderPrimary};
`;

const createGridLayout = (columnLength = 0) => `minmax(220px, 1fr) repeat(${columnLength}, 160px)`;

/** SMS Breakdown table */
export const MessagingAnalyticTable = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { BillingDisplayBccCcEmailsUI } = useSelector(selectFeatureFlags);
  const {
    billingPeriodMetrics: { ByOrgProviderBillingParty = [] },
    orgMetricsByName,
  } = useQueryContext();

  const { smsColumns, smsRows } = useMemo(() => {
    const smsMetrics = ByOrgProviderBillingParty[0] || [];
    const columnMemo = createSmsTableColumns(smsMetrics);
    const rowMemo = createSmsTableRows(smsMetrics);
    return { smsColumns: columnMemo, smsRows: rowMemo };
  }, [ByOrgProviderBillingParty]);

  const emailRows: TableMetric[] = useMemo(() => {
    return createEmailTableRows(orgMetricsByName);
  }, [orgMetricsByName]);

  return (
    <>
      <TableActionWrapper>
        <Button onClick={() => setIsCollapsed((prev) => !prev)} variant={BUTTON_VARIANTS.TEXT}>
          <CollapsibleContentArrow
            arrowEnd={ARROW_DIRECTION_UP}
            arrowStart={ARROW_DIRECTION_RIGHT}
            isCollapsed={isCollapsed}
          />
          <span>{isCollapsed ? 'Show' : 'Hide'} breakdown</span>
        </Button>
      </TableActionWrapper>
      <CollapsibleContent isCollapsed={isCollapsed}>
        {BillingDisplayBccCcEmailsUI && (
          <AnalyticTable
            columns={EMAIL_BREAKDOWN_TABLE_COLUMNS}
            gridLayout={createGridLayout(EMAIL_BREAKDOWN_TABLE_COLUMNS.length - 1)}
            metrics={emailRows}
          />
        )}
        <AnalyticTable
          columns={smsColumns}
          gridLayout={createGridLayout(smsColumns.length - 1)}
          metrics={smsRows}
        />
      </CollapsibleContent>
    </>
  );
};
